module.exports = __webpack_public_path__ + "img/nanjingyh.1917e08c.png";